import styles from "./GraphData.module.css"
import graph_image from "../../../images/PositionGraph.png"

const GraphData = ({posDetail}) => {
  return (
    <div className={styles.graph_data_container}>
            <div className={styles.graph_data_image}>
            <img src={graph_image} alt="graph " />
            </div>
            <div className={styles.graph_data_content}>
            <div className={styles.position_info_row}>
                    <span>Pooled {posDetail.baseTokenSymbol}</span>
                    <div className={styles.graph_data_token}>1.69 <img src={posDetail.baseTokenImage} alt="token 1" width="15px"/></div>
                </div>
            <div className={styles.position_info_row}>
                    <span>Pooled {posDetail.quoteTokenSymbol}</span>
                    <div className={styles.graph_data_token}>1.690.0 <img src={posDetail.quoteTokenImage} alt="token 2" width="15px"/></div>
                </div>
                <section>

            <div className={styles.position_info_row}>
                    <span>{posDetail.baseTokenSymbol} Fees Earned</span>
                    <div className={styles.graph_data_token}>0.06 <img src={posDetail.baseTokenImage} alt="token 1" width="15px"/></div>
                </div>
                  <div className={styles.position_info_row}>
                    
                    <span>{posDetail.quoteTokenSymbol} Fees Earned</span>
                    <div className={styles.graph_data_token}>60.9 <img src={posDetail.quoteTokenImage} alt="token 2" width="15px"/></div>
                </div>
                </section>

                <div className={styles.min_max_container}>
                    <div className={styles.position_info_row}>
                        <div className={styles.min_content}>
                            Min Price <span>$2100.00</span>
                    </div>
                        <div className={styles.max_content}>
                            Max Price <span>$4000.00</span>
                    </div>
                    </div>
                </div>

            </div>
        </div>
  )
}

export default GraphData